import axios from "components/AxiosUtils";
import { FileInfo } from "features/Entity/Agreement";
import { PlacementInfo } from "features/Entity/PlacementInfo";

export async function getPlacementInfoRep(applicationFormUid: string): Promise<PlacementInfo> {
  try {
    const response = await axios.get<PlacementInfo>(
      `/PlacementInfo/GetPlacementInfoForApplicationForm/${applicationFormUid}`
    );

    return response.data;
  } catch (err: any) {
    throw err;
  }
}

export async function downloadPlacementInfoDocumentRep(placementDocumentUid: string, placementDocumentName: string): Promise<FileInfo>
{
    try
    {
        const response = await axios.get<ArrayBuffer>(
            `/PlacementInfo/GetPlacementDocumentFile/${placementDocumentUid}`,
            {headers: { "Content-Type": "application/octet-stream"}, responseType: 'arraybuffer'}
        );

        const blob = new Blob([new Uint8Array(response.data)]);
        const fileInfo: FileInfo = { fileBlob: blob, filename: `${placementDocumentName}` };
        return fileInfo;
    }
    catch (err: any) {
        throw err;
    }
}

export async function getPlacementApplicationFormFileRep(placementInfoUid: string, applicationformFileName: string): Promise<FileInfo>
{
    try
    {
        const response = await axios.get<ArrayBuffer>(
            `/PlacementInfo/GetPlacementApplicationFormFile/${placementInfoUid}`,
            {headers: { "Content-Type": "application/octet-stream"}, responseType: 'arraybuffer'}
        );

        const blob = new Blob([new Uint8Array(response.data)]);
        const fileInfo: FileInfo = { fileBlob: blob, filename: `${applicationformFileName}` };
        return fileInfo;
    }
    catch (err: any) {
        throw err;
    }
}